import { getLocalUser } from "../utils";

const BASE = "/api/gearSubmissions";

// Every call resolves to the parsed body plus `ok`, so callers can show the
// server's validation errors instead of a generic failure.
const request = async (path, { method = "GET", body, auth = true } = {}) => {
  const user = getLocalUser();
  const headers = { Accept: "application/json", "Content-Type": "application/json" };
  if (auth && user && user.token) headers.Authorization = `Bearer ${user.token}`;
  try {
    const response = await fetch(`${BASE}${path}`, {
      method,
      headers,
      body: body ? JSON.stringify(body) : undefined,
    });
    const data = await response.json().catch(() => ({}));
    return { ok: response.ok, ...data };
  } catch (error) {
    return { ok: false, error: "Network error, please try again" };
  }
};

export const fetchSubmissionFields = () => request("/fields", { auth: false });

export const submitGear = ({ gearType, items, source, note }) =>
  request("/submit", { method: "POST", body: { gearType, items, source, note } });

export const fetchMySubmissions = () => request("/mine");

export const fetchSubmissionQueue = ({ status, gearType }) => {
  const params = new URLSearchParams({ status });
  if (gearType) params.set("gearType", gearType);
  return request(`/admin?${params.toString()}`);
};

export const updateSubmission = (id, data) =>
  request(`/admin/${id}`, { method: "PATCH", body: { data } });

export const publishSubmission = (id, addToAutocomplete) =>
  request(`/admin/${id}/publish`, { method: "POST", body: { addToAutocomplete } });

export const rejectSubmission = (id, reason) =>
  request(`/admin/${id}/reject`, { method: "POST", body: { reason } });

export const bulkReviewSubmissions = ({ ids, action, reason, addToAutocomplete }) =>
  request("/admin/bulk", { method: "POST", body: { ids, action, reason, addToAutocomplete } });
